<template>
  <el-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    title="导入日志"
    width="90%"
  >
    <section class="page-container">
      <!-- <div ref="toolbar" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-input v-model="filters.name" placeholder="名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="list">刷新</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleEdit($event)">新增</el-button>
          </el-form-item>
        </el-form>
      </div> -->

      <div ref="mainContent" :style="{ height: mainHeight }">
        <el-table
          v-loading="loading"
          height="100%"
          :data="results"
          highlight-current-row
          stripe
          border
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column type="selection" width="55"></el-table-column> -->
          <el-table-column prop="id" label="编号" width="100"></el-table-column>

          <!-- <el-table-column prop="taskId" label="taskId"></el-table-column> -->

          <!-- <el-table-column prop="type" label="type"></el-table-column> -->

          <el-table-column prop="rowNo" label="行号" width="100"></el-table-column>

          <el-table-column prop="rowData" label="数据"></el-table-column>

          <el-table-column prop="result" label="结果"></el-table-column>

          <el-table-column prop="errorInfo" label="错误信息"></el-table-column>

          <el-table-column prop="success" label="是否成功" width="100">
            <template #default="{ row }">{{ row.success ? "成功" : "失败" }}</template>
          </el-table-column>

          <el-table-column prop="elapsed" label="耗时" width="80">
            <template #default="{ row }">{{ row.elapsed }}ms</template>
          </el-table-column>

          <el-table-column prop="createTime" label="时间" width="160"></el-table-column>

          <!-- <el-table-column label="操作" width="150">
          <template #default="{ row }">
            <el-button size="mini" type="primary" @click="handleEdit(row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column> -->
          <template #empty>
            <el-empty />
          </template>
        </el-table>
      </div>

      <div ref="pagebar" class="pagebar">
        <el-pagination
          :page-sizes="[20, 50, 100, 300]"
          :current-page="page.page"
          :page-size="page.limit"
          :total="page.total"
          layout="total, sizes, prev, pager, next, jumper"
          @current-change="handlePageChange"
          @size-change="handleLimitChange"
        >
        </el-pagination>
      </div>

      <edit ref="editRef" @success="list" />
    </section>
  </el-dialog>
</template>

<script>
// import mainHeight from "@/utils/mainHeight";
import Edit from "./components/Edit";
export default {
  name: "ImportTaskLog",
  components: { Edit },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      loading: true,
      page: {},
      filters: {
        taskId: null,
      },
      selectedRows: [],
      dialogVisible: false,
    };
  },
  mounted() {
    // mainHeight(this);
    // this.list();
  },
  methods: {
    async show(taskId) {
      this.filters.taskId = taskId;
      await this.list();
      this.dialogVisible = true;
    },
    async list() {
      this.loading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        const data = await this.axios.form("mall:/api/admin/import-task-log/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.loading = false;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    handleEdit(row) {
      if (row.id) {
        this.$refs.editRef.showEdit(row);
      } else {
        this.$refs.editRef.showEdit();
      }
    },
    handleDelete(row) {
      const me = this;
      me.$confirm("是否确认删除?")
        .then(() => {
          me.axios
            .form("mall:/api/admin/import-task-log/delete", {
              ids: row.id,
            })
            .then(() => {
              this.$notify.success("删除成功");
              me.list();
            })
            .catch((e) => {
              this.$notify.error(e.message || e);
            });
        })
        .catch((e) => {});
    },
  },
};
</script>

<style lang="scss" scoped></style>
